import ky from 'ky';
import omit from 'lodash/omit';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';
import { z } from 'zod';
import { MANAGEMENT_USER_SCHEMA } from '../get-management-user';

export const CREATE_USER_RESULT_SCHEMA = z.object({
  message: z.string(),
});

export const UPDATE_USER_RESULT_SCHEMA = CREATE_USER_RESULT_SCHEMA;

export const CREATE_USER_SCHEMA = MANAGEMENT_USER_SCHEMA.extend({
  stores: z.array(z.string()),
  orgs: z.array(z.string()),
  role: z.array(z.string()),
});

export type CreateUserSchema = z.infer<typeof CREATE_USER_SCHEMA>;

export const createNewUserPromise = async (user: CreateUserSchema) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    const validateParam = CREATE_USER_SCHEMA.safeParse(user);

    if (!validateParam.success) {
      console.error(validateParam.error);
      return false;
    }

    const response = await ky
      .post(`${ENV.API_URL}/external-user-management/create-new-user/`, {
        body: JSON.stringify(user),
        headers,
      })
      .json();

    const res = CREATE_USER_RESULT_SCHEMA.safeParse(response);

    if (!res.success) {
      console.error(res.error);
      return false;
    }

    return (res?.data?.message || '')?.toLowerCase()?.includes('created');
  } catch (error) {
    console.error('Error creating new user:', error);
    return false;
  }
};

export const updateUserPromise = async (user: Partial<CreateUserSchema>) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    const response = await ky
      .patch(`${ENV.API_URL}/external-user-management/update-user/${user.uuid}/`, {
        body: JSON.stringify(omit(user, ['uuid'])),
        headers,
      })
      .json();

    const res = UPDATE_USER_RESULT_SCHEMA.safeParse(response);

    if (!res.success) {
      console.error(res.error);
      return false;
    }

    return (res?.data?.message || '')?.toLowerCase()?.includes('updated');
  } catch (error) {
    console.error('Error updating user:', error);
    return false;
  }
};
